//import React from 'react'
import { Component } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';

const AuthorizeRouteParent = props => {
  const { tenantId } = useParams();
  return <AuthorizeRoute {...props} tenantId={tenantId} />;
};

class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      authenticated: false
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.authenticationChanged());
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  render() {
    const { ready, authenticated } = this.state;
    let link = document.createElement('a');
    link.href = this.props.path;
    document.cookie = `tenantId=${this.props.tenantId}; path=/`;
    const baseUrl = document.baseURI.endsWith('/') ? document.baseURI.slice(0, -1) : document.baseURI;
    let returnUrl = `${baseUrl}${link.pathname}${link.search}${link.hash}`;
    returnUrl = returnUrl.replace(':tenantId', this.props.tenantId);
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`;
    if (!ready) {
      return <div></div>;
    } else {
      const { element } = this.props;
      return authenticated ? element : <Navigate replace to={redirectUrl} />;
    }
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated });
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }
}

export default AuthorizeRouteParent;
